module.exports = __webpack_public_path__ + "static/home.8c56fd61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home.png
// module id = ./src/assets/images/home.png
// module chunks = 35783957827783